module.exports = __webpack_public_path__ + "static/media/icon_tag.843ce980.svg";